window.UserTrackingManagerAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['UserTrackingManagerServer']);

    self.getBrandRumSettings = function (brandId) {

        var deferred = $q.defer();

        if (!brandId || typeof brandId !== 'number') {
            console.error('no brand id');
            deferred.resolve({is_enabled: false, sampling_percentage: 0});
            return deferred.promise;
        }

        _protected.request('brands/' + brandId + '/rum_settings', 'GET')
            .then(function (res) {
                if (res && res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data['brand_rum_setting']);
                } else {
                    deferred.resolve({is_enabled: false, sampling_percentage: 0});
                }
            })
            .catch(function (err) {
                console.error(err);
                deferred.resolve({is_enabled: false, sampling_percentage: 0});
            });

        return deferred.promise;
    };
});
